import {Button, Form, FormGroup, Grid, Header, Segment} from 'semantic-ui-react'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import React from 'react'
import 'rc-time-picker/assets/index.css';
import {tripHours} from "../misc/Helpers";
import {tripMins} from "../misc/Helpers";

function TripForm({
                    fromCity,
                    toCity,
                    tripDate,
                    tripHour,
                    tripMin,
                    cost,
                    maxPassengers,
                    notes,
                    handleInputChange,
                    handleCreateTrip,
                    showCalendar,
                    setShowCalendar,
                    handleDateChange
                  }) {
  const createBtnDisabled = cost === '' || maxPassengers === ''
    || tripDate === '' || tripHour === ''
    || tripMin === '' || fromCity === '' || toCity === ''

  const maxPassengerOptions = [{key: 1, value: '1', text: '1'}, {key: 2, value: '2', text: '2'},
    {key: 3, value: '3', text: '3'}, {key: 4, value: '4', text: '4'}, {key: 5, value: '5', text: '5'},
    {key: 6, value: '6', text: '6'}, {key: 7, value: '7', text: '7'}
  ]

  const dateStyle = () => {
    return showCalendar ? {"display": "none"} : {"display": "flex"}
  }

  return (
    <div>
      <Header as='h1' textAlign='center'>Создать Поездку</Header>
      <Grid textAlign='center'>
        <Grid.Column style={{maxWidth: 450}}>
          <Form size='large' onSubmit={handleCreateTrip}>
            <Segment>
              <Form.Input
                label='Город Отправления'
                name='fromCity'
                value={fromCity}
                onChange={handleInputChange}
              />
              <Form.Input
                label='Город Прибытия'
                name='toCity'
                value={toCity}
                onChange={handleInputChange}
              />
              <Form.Input
                style={dateStyle()}
                label='Укажите дату'
                value={tripDate}
                onFocus={() => setShowCalendar(true)}
              />
              <Calendar
                className={showCalendar ? "" : "hide"}
                name='tripDate'
                onChange={handleDateChange}
                value={tripDate}
              />
              <Form.Dropdown
                label='Примерное время отправления'
                selection
                name='tripHour'
                options={tripHours}
                value={tripHour}
                onChange={handleInputChange}
              />
              <Form.Dropdown
                selection
                label=' '
                name='tripMin'
                options={tripMins}
                value={tripMin}
                onChange={handleInputChange}
              />
              <Form.Dropdown
                selection
                label='Какое количество пассажиров готовы взять?'
                name='maxPassengers'
                options={maxPassengerOptions}
                value={maxPassengers}
                onChange={handleInputChange}
              />
              <Form.Input
                label='Стоимость поездки для каждого пассажира (BYN)'
                name='cost'
                value={cost}
                onChange={handleInputChange}
                type='number'
              />
              <Form.TextArea
                label='Дополнительная информация'
                name={'notes'}
                value={notes}
                onChange={handleInputChange}
              />
              <Button icon fluid color='blue' size='large' disabled={createBtnDisabled}>
                Сохранить
              </Button>
            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    </div>
  )
}

export default TripForm
